module.exports = __webpack_public_path__ + "static/media/close.9335a5ee.svg";